import React from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import Footer from './Footer';

export default props => (
  <React.Fragment>
    <NavMenu />
    <Container className="py-4">
      {props.children}
    </Container>
    <Footer />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/Layout.js